import { render, staticRenderFns } from "./ReturnPartsDetail.vue?vue&type=template&id=3c081ad0"
import script from "./ReturnPartsDetail.vue?vue&type=script&lang=js"
export * from "./ReturnPartsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c081ad0')) {
      api.createRecord('3c081ad0', component.options)
    } else {
      api.reload('3c081ad0', component.options)
    }
    module.hot.accept("./ReturnPartsDetail.vue?vue&type=template&id=3c081ad0", function () {
      api.rerender('3c081ad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsDetail.vue"
export default component.exports